/* 28/09/2026 (Isma) : les vidéos de la galerie produit s'ouvrent dans une popup plein écran
   (format d'origine, jamais recadrées), au lieu de se lire dans la case carrée de la galerie. */
(function () {
  if (window.EVS_VPOP) return;
  window.EVS_VPOP = 1;
  var box, stage;
  function build() {
    if (box) return;
    var st = document.createElement('style');
    st.textContent =
      '.evs-vpop{position:fixed;inset:0;z-index:2147483600;display:none;align-items:center;justify-content:center;background:rgba(10,18,24,.88);padding:16px}' +
      '.evs-vpop.is-open{display:flex}' +
      '.evs-vpop__stage{position:relative;max-width:min(1200px,94vw);max-height:88vh;display:flex}' +
      '.evs-vpop__stage video{display:block;object-fit:contain;background:#000;border-radius:10px}' +
      '.evs-vpop__stage iframe{display:block;width:min(1200px,94vw);aspect-ratio:16/9;max-height:88vh;border:0;border-radius:10px;background:#000}' +
      '.evs-vpop__x{position:absolute;top:12px;right:12px;width:44px;height:44px;border-radius:50%;border:0;background:#fff;color:#10222D;font-size:26px;line-height:44px;cursor:pointer;z-index:2}' +
      'html.evs-vpop-lock,html.evs-vpop-lock body{overflow:hidden!important}';
    document.head.appendChild(st);
    box = document.createElement('div');
    box.className = 'evs-vpop';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<button type="button" class="evs-vpop__x" aria-label="Close">×</button><div class="evs-vpop__stage"></div>';
    stage = box.querySelector('.evs-vpop__stage');
    document.body.appendChild(box);
    box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('.evs-vpop__x')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('is-open')) close(); });
  }
  function close() {
    var v = stage.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} }
    stage.innerHTML = '';
    box.classList.remove('is-open');
    document.documentElement.classList.remove('evs-vpop-lock');
  }
  function open(dm) {
    var tpl = dm.querySelector('template');
    if (!tpl) return false;
    var node = tpl.content.querySelector('video, iframe');
    if (!node) return false;
    build();
    node = node.cloneNode(true);
    if (node.tagName === 'VIDEO') {
      node.controls = true; node.autoplay = true; node.muted = false; node.removeAttribute('muted'); node.setAttribute('preload', 'auto');
      node.setAttribute('playsinline', ''); node.removeAttribute('loop');
      node.removeAttribute('width'); node.removeAttribute('height'); node.removeAttribute('style');
      node.className = '';
    } else {
      var s = node.getAttribute('src') || '';
      if (s && !/autoplay=1/.test(s)) node.setAttribute('src', s + (s.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
      node.removeAttribute('width'); node.removeAttribute('height'); node.removeAttribute('style');
      node.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    }
    stage.innerHTML = '';
    stage.appendChild(node);
    box.classList.add('is-open');
    document.documentElement.classList.add('evs-vpop-lock');
    if (node.tagName === 'VIDEO') {
      /* taille exacte au format de la vidéo (ratio de l'affiche en attendant les métadonnées) */
      var fit = function (r) {
        if (!r || !isFinite(r)) return;
        var w = Math.min(window.innerWidth * 0.94, 1200), h = w / r, mh = window.innerHeight * 0.88;
        if (h > mh) { h = mh; w = h * r; }
        node.style.width = Math.round(w) + 'px'; node.style.height = Math.round(h) + 'px';
      };
      fit(16 / 9);
      if (node.poster) { var im = new Image(); im.onload = function () { if (!node.videoWidth) fit(im.naturalWidth / im.naturalHeight); }; im.src = node.poster; }
      node.addEventListener('loadedmetadata', function () { fit(node.videoWidth / node.videoHeight); });
      window.addEventListener('resize', function () { if (node.isConnected) fit(node.videoWidth ? node.videoWidth / node.videoHeight : parseFloat(node.style.width) / parseFloat(node.style.height)); });
      var p = node.play(); if (p && p.catch) p.catch(function () {});
    }
    return true;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-media deferred-media .js-load-media, .media-gallery deferred-media .js-load-media, media-gallery deferred-media .js-load-media');
    if (!btn) return;
    var dm = btn.closest('deferred-media');
    if (dm && open(dm)) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
  }, true);
})();
